import React from 'react'
import StoreHighlightImage from './StoreHighlightImage'

const StoreHighlights = ({ highlights }) => {
  return !highlights?.length ? null : (
    <>
      <div className="mb-2">
        <h3 className="text-xl font-semibold">Store Highlights</h3>
      </div>
      <section className="flex flex-wrap mb-6 -mx-3">
        {highlights?.map(highlight => {
          return highlight?.serviceName !== 'Bespoke Highlights' ? (
            <article
              key={highlight.name}
              className="flex flex-wrap w-1/2 px-3 mx-0 mb-6 lg:w-1/4"
            >
              <section className="flex flex-col w-full h-full bg-white rounded-b-lg shadow-md">
                <StoreHighlightImage name={highlight?.name} />

                <div className="p-3">
                  <h2 className="text-lg font-semibold">
                    {highlight?.serviceName}
                  </h2>
                </div>
              </section>
            </article>
          ) : null
        })}
      </section>
    </>
  )
}

export default StoreHighlights
